import { Mail, MessageSquare, Clock, AlertTriangle, Ban, Check } from "lucide-react";

const STATUS_STYLE = {
  sent: { dot: "bg-[#5B9E7A]", text: "text-[#4C8C8C]", label: "Sent", Icon: Check },
  failed: { dot: "bg-[#C97B7B]", text: "text-[#C97B7B]", label: "Failed", Icon: AlertTriangle },
  blocked: { dot: "bg-slate-400", text: "text-slate-500", label: "Blocked", Icon: Ban },
  needs_review: { dot: "bg-[#D8A657]", text: "text-[#B8873C]", label: "Needs review", Icon: AlertTriangle },
  claimed: { dot: "bg-slate-300", text: "text-slate-400", label: "Sending…", Icon: Clock },
  none: { dot: "bg-slate-200", text: "text-slate-400", label: "Not sent", Icon: Clock },
};

export const DeliveryStatusChip = ({ label, channel, block, testId }) => {
  const s = STATUS_STYLE[block?.status] || STATUS_STYLE.none;
  const ChannelIcon = channel === "email" ? Mail : MessageSquare;
  return (
    <div
      className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-xs"
      title={block?.error || s.label}
      data-testid={testId}
    >
      <ChannelIcon className="w-3 h-3 text-slate-400" />
      <span className="text-slate-500">{label}</span>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      <span className={s.text}>{s.label}</span>
    </div>
  );
};
